export default __webpack_public_path__ + "static/media/brand-logo-white.850a7388.svg";